function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 8,
  height: 12,
  fill: "none",
  viewBox: "0 0 8 12",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#292A2B",
  d: "M6 12 0 6l6-6 1.4 1.4L2.8 6l4.6 4.6z"
}));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-chevron-left.svg";
export { SvgComponent as ReactComponent };